/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Wipe_Warning_EmphasisInputs */

const fr_vehicle_action_archive_wipe_warning_emphasis = /** @type {(inputs: Vehicle_Action_Archive_Wipe_Warning_EmphasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`si et seulement si`)
};

const en_vehicle_action_archive_wipe_warning_emphasis = /** @type {(inputs: Vehicle_Action_Archive_Wipe_Warning_EmphasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`only if`)
};

/**
* | output |
* | --- |
* | "only if" |
*
* @param {Vehicle_Action_Archive_Wipe_Warning_EmphasisInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_wipe_warning_emphasis = /** @type {((inputs?: Vehicle_Action_Archive_Wipe_Warning_EmphasisInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Wipe_Warning_EmphasisInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_wipe_warning_emphasis(inputs)
	return en_vehicle_action_archive_wipe_warning_emphasis(inputs)
});